var data = {
	"body": "<path d=\"M1280 576q0-26-19-45t-45-19t-45 19t-19 45t19 45t45 19t45-19t19-45zm128 0q0 62-35.5 111t-92.5 70v395q0 159-131.5 271.5T832 1536t-316.5-112.5T384 1152v-132q-164-20-274-128T0 640V128q0-26 19-45t45-19q6 0 16 2q17-30 47-48t65-18q53 0 90.5 37.5T320 128t-37.5 90.5T192 256q-33 0-64-18v402q0 106 94 181t226 75t226-75t94-181V238q-31 18-64 18q-53 0-90.5-37.5T576 128t37.5-90.5T704 0q35 0 65 18t47 48q10-2 16-2q26 0 45 19t19 45v512q0 144-110 252t-274 128v132q0 106 94 181t226 75t226-75t94-181V757q-57-21-92.5-70T1024 576q0-80 56-136t136-56t136 56t56 136z\" fill=\"currentColor\"/>",
	"width": 1408,
	"height": 1536
};
exports.__esModule = true;
exports.default = data;
